/* <article-share> — share the current article.

   Replaces a link labelled "Kopijuoti nuorodą" whose href was literally "#": it
   looked like a control, and did nothing when a customer clicked it.

   Progressive enhancement: the markup ships a real <a> to the article URL, so
   with no JS the row is still a working link. When JS runs, the button prefers
   the platform share sheet and falls back to the clipboard, confirming through a
   live region so screen-reader users hear it too.

   Strings arrive as data-* attributes from Liquid, so the copy stays in
   locales/* and never gets hardcoded here. */
(function () {
  class ArticleShare extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-share-button]');
      this.status = this.querySelector('[data-share-status]');
      if (!this.button) return;

      this.url = this.getAttribute('data-url') || window.location.href;
      this.title = this.getAttribute('data-title') || document.title;

      var canShare = typeof navigator.share === 'function';
      var canCopy = !!(navigator.clipboard && navigator.clipboard.writeText);
      /* Neither capability — leave the no-JS link exactly as rendered. */
      if (!canShare && !canCopy) return;

      this.onClick = this.onClick.bind(this);
      this.button.addEventListener('click', this.onClick);
      this.button.hidden = false;
      var fallbackLink = this.querySelector('[data-share-fallback]');
      if (fallbackLink) fallbackLink.hidden = true;
    }

    disconnectedCallback() {
      if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
      if (this.timer) clearTimeout(this.timer);
    }

    onClick(event) {
      event.preventDefault();
      var payload = { title: this.title, url: this.url };
      if (typeof navigator.share === 'function') {
        /* A dismissed share sheet rejects with AbortError — not an error state,
           so it must not surface a message. */
        navigator.share(payload).catch(function () {});
        return;
      }
      var self = this;
      navigator.clipboard.writeText(this.url).then(
        function () { self.announce(self.getAttribute('data-copied')); },
        function () { self.announce(self.getAttribute('data-copy-failed')); }
      );
    }

    announce(message) {
      if (!this.status || !message) return;
      this.status.textContent = message;
      this.status.classList.add('is-visible');
      if (this.timer) clearTimeout(this.timer);
      var self = this;
      this.timer = setTimeout(function () {
        self.status.textContent = '';
        self.status.classList.remove('is-visible');
      }, 2400);
    }
  }

  if (!customElements.get('article-share')) {
    customElements.define('article-share', ArticleShare);
  }
})();
